<div #accelaControlDiv [id]="getDivElementId()" class="datepicker accelaControl textinput" [formGroup]="controlRef.parent">
  <label [for]="getLabelElementId()" [id]="getLabelElementId()" [attr.data-required]="controlData.required">{{this.label}}</label>
  <p-calendar [formControlName]="controlData.name" [name]="controlData.name" [id]="controlData.name" [ariaLabelledBy]="getLabelElementId()" [attr.aria-required]="controlData.required"
              [disabled]="adminMode" appendTo="body" [required]="controlData.required" [readonlyInput]="controlData.readOnly || readonlyMode"
              [placeholder]="controlData.placeholder"  [timeOnly]="true" hourFormat="12" placeholder="00:00 PM" readonlyInput="true"
              tooltipEvent="hover|focus" [accelaTooltip]="controlData.tooltip" tooltipPosition="bottom"
              [escape]="false" (onBlur)="emitBlurEvent($event)">
  </p-calendar>
</div>
<div *ngIf="!adminMode" class="validationFeedback">
  <small *ngIf="controlRef?.errors?.required && (controlRef?.touched || controlRef?.dirty)"
         class="ng-invalid p-invalid">
    {{this.getRequiredFieldValidationMsg()}}
  </small>
</div>
